import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e78a7bf&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2e78a7bf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e78a7bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e78a7bf')) {
      api.createRecord('2e78a7bf', component.options)
    } else {
      api.reload('2e78a7bf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e78a7bf&scoped=true", function () {
      api.rerender('2e78a7bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BjExcelImportDialog/index.vue"
export default component.exports